import { getAddressInitialValues } from '../../utils';
import { EMPTY_SEPARATE_UNIT, optionToEntityMap } from './constants';
import { TRelatedCompanies, TRelatedEntity } from './types';

export const getInitialValues = (formData: TRelatedCompanies) => ({
  isSeparateUnitsAbsent: formData?.isSeparateUnitsAbsent || false,
  separateUnits: formData?.isSeparateUnitsAbsent
    ? []
    : formData?.separateUnits?.length
      ? formData?.separateUnits.map((unit) => ({
          fullName: unit?.fullName || null,
          identificationNumber: unit?.identificationNumber || null,
          residenceCountry: unit?.residenceCountry || null,
          unitRegistrationDate: unit?.unitRegistrationDate || null,
          address: getAddressInitialValues(unit),
          separateUnitType: unit?.separateUnitType || null,
        }))
      : [EMPTY_SEPARATE_UNIT],
  relatedEntityInfo: {
    entity: formData?.relatedEntityInfo?.entity || undefined,
    fullName: formData?.relatedEntityInfo?.fullName || undefined,
    residenceCountry: formData?.relatedEntityInfo?.residenceCountry || undefined,
    identificationNumber: formData?.relatedEntityInfo?.identificationNumber || undefined,
    address:
      formData?.relatedEntityInfo?.entity === optionToEntityMap.option0
        ? undefined
        : getAddressInitialValues(formData?.relatedEntityInfo as TRelatedEntity),
  },
});
